import { LifeBuoy } from 'react-feather'
import { t } from '@lingui/core/macro'

export function HelpCard({ referenceId }: { referenceId: string }) {
  return (
    <div className="flex flex-col items-center rounded-2xl border border-primary/20 bg-primary/[0.06] p-6 text-center">
      <span className="mb-3 flex h-11 w-11 items-center justify-center rounded-full bg-primary/10 text-primary">
        <LifeBuoy size={20} aria-hidden="true" />
      </span>
      <h4 className="text-sm font-semibold text-gray-900">{t`Need help?`}</h4>
      <p className="mt-1 text-sm text-gray-600">{t`Questions about your request? Contact support and quote your reference:`}</p>
      <p className="mt-3 inline-block rounded-md border border-gray-200 bg-white px-3 py-1.5 font-mono text-sm font-semibold text-gray-900 shadow-sm">
        {referenceId || '-'}
      </p>
    </div>
  )
}
